<script setup>
import {ref, onMounted, getCurrentInstance, reactive} from "vue";
import LoadingIcon from "@/components/LoadingIcon.vue";
import { salesListsApi } from "@/api/forsales_index";
import {userApi} from "@/api";

const router = useRouter();
const stepNumber = ref(1);
const showImportModal = ref(false);
const showPromptModal = ref(false);
const check_modal_msg = ref("");

const instance = getCurrentInstance();
const prompt_str = ref("");
const sales_templates = ref([]);
const service_detail_templates = ref([]);
const selected_service_detail_template_id = ref("");

function apply_service_detail_template(template_id) {
  const saleslist = instance.proxy.saleslist
  const selected = service_detail_templates.value.find(
    (item) => parseInt(item.id) === parseInt(template_id)
  )
  if (!selected || !saleslist) {
    return
  }
  saleslist.service_name = selected.service_name || ""
  saleslist.service_detail_summary = selected.service_detail_summary || ""
}

function set_template_text(template_id) {
  // console.log( "template_text..." + template_id)
  let saleslist = instance.proxy.saleslist
  for (let i in sales_templates.value) {
    let id = parseInt(sales_templates.value[i].id)

    if (id === parseInt(template_id)) {
      // console.log( "** template_text:", sales_templates[i].template_text)
      saleslist.template_text = sales_templates.value[i].template_text
    }
  }
}

function formatNewlines(text) {
  if (!text) {
    return '';
  }
  return text.replace(/\\n/g, '<br>');
}

onMounted(async () => {
  try {
    const optionResp = await salesListsApi.check_optionAccess();
    console.log(optionResp)
    if (optionResp.message !== "ok") {
      return router.push(`/forsales/options_error`);
    }
  }
  catch (error) {
    return router.push(`/forsales/options_error`);
  }

  const resp = await salesListsApi.getAllTemplates()
  const data = resp.data
  console.log("data:", data)

  sales_templates.value = data

  const serviceDetailResp = await salesListsApi.getAllServiceDetailTemplates()
  service_detail_templates.value = serviceDetailResp.data || []
});

const openPromptModal = () => {
  prompt_str.value = instance.proxy.$t("EditSalesListsView.prompt_str")
  showPromptModal.value = true;
};

const closePromptModal = () => {
  showPromptModal.value = false;
};

const openImportModal = () => {
  showImportModal.value = true;
};

const closeImportModal = () => {
  showImportModal.value = false;
};

const handleReturn = () => {
  if (stepNumber.value === 1) {
    router.back();
  } else {
    stepNumber.value--;
  }
};

function isEmpty(val) {
  return (
    val == null || (
      typeof val === "string" &&
      val.trim().length === 0
    )
  )
}

function has_empty_fields() {
  let saleslist = instance.proxy.saleslist
  let t = instance.proxy.$t

  let f_list = ""

  if (isEmpty(saleslist.list_name))
    f_list += t('NewSalesListsView.list_name') + "\n"
  if (isEmpty(saleslist.sender_company_name))
    f_list += t('NewSalesListsView.sender_company_name') + "\n"
  if (isEmpty(saleslist.sender_company_url))
    f_list += t('NewSalesListsView.sender_company_url') + "\n"
  if (isEmpty(saleslist.sender_name))
    f_list += t('NewSalesListsView.sender_name') + "\n"
  if (isEmpty(saleslist.sender_mail_address))
    f_list += t('NewSalesListsView.sender_mail_address') + "\n"
  if (isEmpty(saleslist.tel))
    f_list += t('NewSalesListsView.tel') + "\n"
  if (isEmpty(saleslist.mail_title))
    f_list += t('NewSalesListsView.mail_title') + "\n"
  if (isEmpty(saleslist.to_name))
    f_list += t('NewSalesListsView.to_name') + "\n"

  if (isEmpty(saleslist.service_name))
    f_list += t('NewSalesListsView.service_name') + "\n"
  if (isEmpty(saleslist.service_detail_summary))
    f_list += t('NewSalesListsView.service_detail_summary') + "\n"

  if (isEmpty(saleslist.sales_template_id))
    f_list += t('NewSalesListsView.template_name') + "\n"

  if (f_list.length > 0) {
    check_modal_msg.value = t('NewSalesListsView.check_modal_msg') + "\n" + f_list.trim();
    saleslist.is_valid = false;
    return true
  } else {
    saleslist.is_valid = true; 
  }
  return false
}

// 開啟對話框
const openCheckModal = () => {
  let has_empty = has_empty_fields()
  // console.log( "* has_empty", has_empty)

  if (has_empty) {
    // console.log( "** has_empty", has_empty)

    // 顯示警告對話框
    let btn = document.getElementById("showCheckModal");
    btn.click();
  }
  return has_empty
};

// const next = () => {
//   if (!openCheckModal())
//     stepNumber.value++;
// };

const handleCreate = (e) => {
  openCheckModal()
  let handleCreate_2 = instance.proxy.handleCreate_2
  handleCreate_2(e)
};

const openMultiServiceHelp = () => {
  prompt_str.value = instance.proxy.$t("EditSalesListsView.multi_service_help");
  showPromptModal.value = true;
};

// ==== modal_new ====

const modal_new_template = reactive({
  show: false,
  item: {
    template_name: "",
    template_text: ""
  },
  check_modal_msg: "",
  has_empty_fields() {
    let t = instance.proxy.$t
    let f_list = ""

    if( isEmpty( this.item.template_name))
      f_list += t('sales_templates_new.template_name') + ", "
    if( isEmpty( this.item.template_text))
      f_list += t('sales_templates_new.template_text') + ", "

    // has some empty fields...
    if( f_list.length > 0) {
      this.check_modal_msg = f_list.substring( 0, f_list.length-2)
          + t( 'sales_templates_new.check_modal_msg')
      return true
    }
    this.check_modal_msg = ""
    return false
  },
  open() {
    this.check_modal_msg = ""
    this.show = true
  },
  async create()
  {
    let has_empty = this.has_empty_fields()
    if (has_empty) {
      return
    }

    // 這裡插入新增 template 的程式碼

    const user = await userApi.whoami()
    console.log( "user:", user)

    const _dict = {
      "id": 1,
      "template_name": this.item.template_name,
      "template_text": this.item.template_text
    }
    console.log( "_dict:", _dict)

    const resp_create = await
        salesListsApi.create_sales_template( _dict)
    console.log( "resp_create:", resp_create)

    // renew the template drop list
    const resp = await salesListsApi.getAllTemplates()
    const data = resp.data
    console.log("data:", data)
    sales_templates.value = data

    this.show = false
  }
})

const modal_new_service_detail_template = reactive({
  show: false,
  item: {
    template_name: "",
    service_name: "",
    service_detail_summary: "",
  },
  check_modal_msg: "",
  has_empty_fields() {
    let t = instance.proxy.$t
    let f_list = ""

    if (isEmpty(this.item.template_name))
      f_list += t('service_detail_templates_new.template_name') + ", "
    if (isEmpty(this.item.service_name))
      f_list += t('service_detail_templates_new.service_name') + ", "
    if (isEmpty(this.item.service_detail_summary))
      f_list += t('service_detail_templates_new.service_detail_summary') + ", "

    if (f_list.length > 0) {
      this.check_modal_msg = f_list.substring(0, f_list.length - 2)
        + t('service_detail_templates_new.check_modal_msg')
      return true
    }
    this.check_modal_msg = ""
    return false
  },
  open() {
    const saleslist = instance.proxy.saleslist
    this.check_modal_msg = ""
    this.item.template_name = saleslist?.service_name || ""
    this.item.service_name = saleslist?.service_name || ""
    this.item.service_detail_summary = saleslist?.service_detail_summary || ""
    this.show = true
  },
  async create() {
    if (this.has_empty_fields()) {
      return
    }

    const resp_create = await salesListsApi.createServiceDetailTemplate(this.item)
    const created = resp_create.data
    const resp = await salesListsApi.getAllServiceDetailTemplates()
    service_detail_templates.value = resp.data || []
    selected_service_detail_template_id.value = String(created.id)
    apply_service_detail_template(created.id)
    this.show = false
  }
})

</script>

<template>
  <LoadingIcon :is-loading="isLoading"></LoadingIcon>

  <!-- modal_new_template begin-->
  <div v-if="modal_new_template.show">
    <div class="d-modal-content flex-column">

      <div>
        <h3>{{ $t('sales_templates_new.h3') }}</h3>
      </div>

      <!--  company_name-->
      <label for="template_name" class="form-label required">
        {{ $t('sales_templates_new.template_name') }} </label>

      <div class="input-group mb-3">
        <input type="text" class="form-control" id="template_name"
               v-model="modal_new_template.item.template_name">
      </div>

      <!--  company_detail-->
      <label for="template_text" class="form-label required">
        {{ $t('sales_templates_new.template_text') }} </label>

      <div class="input-group mb-3">
      <textarea id="template_text" class="form-control"
                v-model="modal_new_template.item.template_text" rows="8"></textarea>
      </div>

      <div class="modal-body" style="color:red">
        <p>{{ modal_new_template.check_modal_msg }}</p>
      </div>

      <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        <button class="btn btn-primary" type="button"
                @click="modal_new_template.show=false">
          {{ $t('sales_templates_new.cancel')}}</button>

        <button class="btn btn-primary" type="button"
                @click="modal_new_template.create">
          {{ $t('sales_templates_new.new')}}</button>

      </div>

    </div>

  </div>
  <!-- modal_new_template end-->

  <div v-if="modal_new_service_detail_template.show">
    <div class="d-modal-content flex-column">
      <div>
        <h3>{{ $t('service_detail_templates_new.h3') }}</h3>
      </div>

      <label for="service_detail_template_name" class="form-label required">
        {{ $t('service_detail_templates_new.template_name') }}
      </label>
      <div class="input-group mb-3">
        <input type="text" class="form-control" id="service_detail_template_name"
               v-model="modal_new_service_detail_template.item.template_name">
      </div>

      <label for="service_template_service_name" class="form-label required">
        {{ $t('service_detail_templates_new.service_name') }}
      </label>
      <div class="input-group mb-3">
        <input type="text" class="form-control" id="service_template_service_name"
               v-model="modal_new_service_detail_template.item.service_name">
      </div>

      <label for="service_template_service_detail_summary" class="form-label required">
        {{ $t('service_detail_templates_new.service_detail_summary') }}
      </label>
      <div class="input-group mb-3">
        <textarea id="service_template_service_detail_summary" class="form-control"
                  v-model="modal_new_service_detail_template.item.service_detail_summary" rows="8"></textarea>
      </div>

      <div class="modal-body" style="color:red">
        <p>{{ modal_new_service_detail_template.check_modal_msg }}</p>
      </div>

      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
        <button class="btn btn-primary" type="button"
                @click="modal_new_service_detail_template.show=false">
          {{ $t('service_detail_templates_new.cancel') }}
        </button>

        <button class="btn btn-primary" type="button"
                @click="modal_new_service_detail_template.create">
          {{ $t('service_detail_templates_new.new') }}
        </button>
      </div>
    </div>
  </div>

  <div>
    <h3>{{ $t('NewSalesListsView.h3') }}</h3>
  </div>
  <br>

  <!-- Step1: 基本情報 -->
  <div class="form-section">
    <h4 class="form-section-title">{{ $t('NewSalesListsView.title_base')}}</h4>
    <label for="list_name" class="form-label required">{{ $t('NewSalesListsView.list_name') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="list_name" v-model="saleslist.list_name">
    </div>
    <label for="send_mode" class="form-label required">{{ $t('NewSalesListsView.send_mode') }}</label>
    <div class="input-group mb-3">
      <select class="form-control" id="send_mode" v-model="saleslist.send_mode" required>
        <option value="auto">{{ $t('NewSalesListsView.send_mode_auto') }}</option>
        <option value="mail">{{ $t('NewSalesListsView.send_mode_mail') }}</option>
        <option value="form">{{ $t('NewSalesListsView.send_mode_form') }}</option>
      </select>
    </div>
    <label for="sender_mail_address" class="form-label required">{{ $t('NewSalesListsView.sender_mail_address') }}</label>
    <div class="input-group mb-3">
      <input type="email" class="form-control" id="sender_mail_address" v-model="saleslist.sender_mail_address">
    </div>
    <label for="sender_company_name" class="form-label required">{{ $t('NewSalesListsView.sender_company_name') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="sender_company_name" v-model="saleslist.sender_company_name">
    </div>
    <label for="sender_company_url" class="form-label required">{{ $t('NewSalesListsView.sender_company_url') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="sender_company_url" v-model="saleslist.sender_company_url">
    </div>
    <label for="sender_name" class="form-label required">{{ $t('NewSalesListsView.sender_name') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="sender_name" v-model="saleslist.sender_name">
    </div>
    <label for="furigana" class="form-label">{{ $t('NewSalesListsView.furigana') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="furigana" v-model="saleslist.furigana">
    </div>
    <label for="gender" class="form-label">{{ $t('NewSalesListsView.gender') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="gender" v-model="saleslist.gender">
    </div>
    <label for="pref" class="form-label">{{ $t('NewSalesListsView.pref') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="pref" v-model="saleslist.pref">
    </div>
    <label for="city" class="form-label">{{ $t('NewSalesListsView.city') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="city" v-model="saleslist.city">
    </div>
    <label for="street_number" class="form-label">{{ $t('NewSalesListsView.street_number') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="street_number" v-model="saleslist.street_number">
    </div>
    <label for="building_name" class="form-label">{{ $t('NewSalesListsView.building_name') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="building_name" v-model="saleslist.building_name">
    </div>
    <label for="postal_code" class="form-label">{{ $t('NewSalesListsView.postal_code') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="postal_code" v-model="saleslist.postal_code">
    </div>
    <label for="tel" class="form-label required">{{ $t('NewSalesListsView.tel') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="tel" v-model="saleslist.tel">
    </div>
    <label for="mail_title" class="form-label required">{{ $t('NewSalesListsView.mail_title') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="mail_title" v-model="saleslist.mail_title">
    </div>
    <label for="to_name" class="form-label required">{{ $t('NewSalesListsView.to_name') }}</label>
    <div class="input-group mb-3">
      <input type="text" class="form-control" id="to_name" v-model="saleslist.to_name">
    </div>
    <label for="to_name" class="form-label">{{ $t('NewSalesListsView.bcc') }}</label>
    <div class="input-group mb-3">
      <input type="email" class="form-control rounded" placeholder="name@example.com" id="bcc">
    </div>
    <label for="file-upload" class="form-label">{{ $t('NewSalesListsView.file_upload') }}</label>
    <div class="form-group mb-3">
      <input class="form-control" type="file" accept="application/pdf" ref="fileInput" @change="onFileChangeMail" id="formFile">
    </div>
    <div class="text-danger">
      {{ $t('NewSalesListsView.must_pdf') }}
    </div>
  </div>

  <!-- Step2: 商品/サービスの情報 -->
  <div class="form-section">
    <h4 class="form-section-title">{{ $t('NewSalesListsView.title_service') }}</h4>
    <div class="form-group mb-3">
      <label class="form-label" for="multi_service_flag">
        {{ $t('NewSalesListsView.multi_service_flag') }}
        <span class="prompt" @click.stop.prevent="openMultiServiceHelp" style="cursor:pointer;"></span>
      </label>
      <label class="switch" style="vertical-align: middle;">
        <input type="checkbox" id="multi_service_flag" v-model="saleslist.multi_service_flag" />
        <span class="slider round"></span>
      </label>
      <span style="margin-left: 0.2em;">{{ saleslist.multi_service_flag ? 'ON' : 'OFF' }}</span>
    </div>
    <div v-if="!saleslist.multi_service_flag">
      <label for="service_name" class="form-label required">
        {{ $t('EditSalesListsView.service_name') }}
      </label>
      <div class="input-group mb-3">
        <input type="text" class="form-control" id="service_name" v-model="saleslist.service_name">
      </div>
    </div>
    <!-- <label for="service_detail_summary" class="form-label required">
      {{ $t('NewSalesListsView.service_detail_summary') }}</label> -->
    <table class="table table-hover">
      <tbody>
      <tr>
        <td>
          <label for="service_detail_summary" class="form-label required">
            {{ $t('NewSalesListsView.service_detail_summary') }}</label>
        </td>
        <td>
          <select
            v-model="selected_service_detail_template_id"
            class="form-select"
            style="width: 240px; display: inline-block; margin-right: 8px;"
          >
            <option value="">{{ $t('NewSalesListsView.service_detail_template_name') }}</option>
            <option
              v-for="item in service_detail_templates"
              :key="item.id"
              :value="String(item.id)"
            >
              {{ item.template_name }}
            </option>
          </select>
          <button class="btn btn-outline-primary" type="button"
                  style="margin-right: 8px;"
                  @click="apply_service_detail_template(selected_service_detail_template_id)"
                  :disabled="!selected_service_detail_template_id">
            {{ $t('NewSalesListsView.service_detail_template_apply') }}
          </button>
          <button class="btn btn-outline-secondary" type="button" @click="modal_new_service_detail_template.open">
            {{ $t('NewSalesListsView.service_detail_template_save') }}
          </button>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>
          <button class="btn btn-import" type="button" @click="openImportModal">
            {{ $t('NewSalesListsView.import') }}</button>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="input-group mb-3">
      <textarea class="form-control" id="service_detail_summary" v-model="saleslist.service_detail_summary" rows="7"></textarea>
    </div>
  </div>

  <!-- Step3: テンプレート選択 -->
  <div class="form-section">
    <h4 class="form-section-title">{{ $t('NewSalesListsView.title_template') }}</h4>

    <div class="form-group">

<!--      label of select template-->
      <label for="template_id" class="form-label required">
        {{ $t('NewSalesListsView.template_name') }}</label>

<!--      combo of select template-->
      <select id="template_id" class="form-input" @change="set_template_text($event.target.value)"
        v-model="saleslist.sales_template_id" style="width: 300px">
        <option value="">-</option>
        <option v-for="item in sales_templates" :value="String(item.id)" :key="item.id">
          {{ item.template_name }}
        </option>
      </select>

<!--      button new template-->
      <button class="btn btn-primary" @click="modal_new_template.open"
              style="padding: 10px 50px; margin: 10px;">
        {{ $t('sales_templates.handle_create') }}</button>

    </div>

    <div class="input-group mb-3">
      <div class="form-control" id="template_text" v-html="formatNewlines(saleslist.template_text)"
        style="white-space: pre-wrap;"></div>
    </div>

    <label for="additional_prompt" class="form-label prompt" @click="openPromptModal">
      {{ $t('NewSalesListsView.additional_prompt') }}</label>
    <div class="input-group mb-3">
      <textarea class="form-control" id="additional_prompt" rows="7" v-model="saleslist.additional_prompt"></textarea>
    </div>

  </div>

  <!-- ボタン -->
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button class="btn btn-primary" type="button" @click="handleReturn">
      {{ $t('NewSalesListsView.return') }}</button>
    <button class="btn btn-primary" type="button" @click="handleCreate($event)">
      {{ $t('NewSalesListsView.finished') }}</button>
  </div>

  <!-- Import modal begin -->
  <div v-if="showImportModal" id="ImportModal" class="modal-import">
    <div class="d-modal-content flex-column">

      <!-- 閉じるボタン -->
      <div class="d-flex justify-content-end">
        <button type="button" class="btn-close" aria-label="Close" @click="closeImportModal"></button>
      </div>

      <!-- select menu-->
      <div class="form-group">
        <label for="resource-type" class="form-label">
          {{ $t('ChatResourceUploadView.resource_type') }}</label>
        <select v-model="resourceType" id="resource-type" class="form-input">
          <option value="file">{{ $t('ChatResourceUploadView.file') }}</option>
          <option value="web">Web</option>
        </select>
      </div>

      <!-- file selected -->
      <div v-if="resourceType === 'file'">
        <div class="form-group">
          <label for="file-upload" class="form-label required">
            {{ $t('ChatResourceUploadView.choose_file') }}
          </label>
          <input id="file-upload" type="file" @change="onFileChange" class="form-input" />
        </div>
        <button @click="uploadFile" class="upload-button rounded btn btn-primary">
          {{ $t('ChatResourceUploadView.upload') }}
        </button>
      </div>

      <!-- web selected -->
      <div v-if="resourceType === 'web'">
        <div class="form-group">
          <label for="document-url" class="form-label required">URL</label>
          <input id="document-url" type="text" v-model="document_url" placeholder="https://vector-flux.com/"
            class="form-input" />
        </div>
        <button @click="uploadWebResource" class="upload-button rounded btn btn-primary">
          {{ $t('ChatResourceUploadView.uploadWebResource') }}
        </button>
      </div>

      <p v-if="responseMessage" class="response-message">{{ responseMessage }}</p>

      <!-- hided button for close form -->
      <button id="btnClose" class="w-100 btn btn-secondary mt-3" style="height: 48px;" @click="closeImportModal">
        {{ $t("EditSalesListsView.check_modal_close") }}
      </button>
    </div>
  </div>
  <!-- Import modal end -->

  <!-- Check modal begin -->
  <button id="showCheckModal" data-bs-toggle="modal" data-bs-target="#CheckModal" style="display:none;"></button>
  <div class="modal fade" id="CheckModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ $t('NewSalesListsView.check_modal_title') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{ check_modal_msg }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
            {{ $t('NewSalesListsView.check_modal_close') }}</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Check modal end -->

   <!-- prompt modal begin-->
  <div v-if="showPromptModal">
    <div class="d-modal-content flex-column">
      <p v-html=prompt_str></p>
      <button class="btn btn-primary" @click="closePromptModal">
        {{ $t("EditSalesListsView.check_modal_close") }}
      </button>
    </div>
  </div>
  <!-- prompt modal end-->

</template>

<script>
import { upsertFileApi, upsertScrapeApi } from "@/api";
import { useRouter } from "vue-router";
import Tagify from '@yaireo/tagify';
import '@yaireo/tagify/dist/tagify.css';

export default {

  data() {
    return {

      saleslist:
      {
        list_name: "",
        sender_company_name: "",
        sender_company_url: "",
        sender_name: "",
        sender_mail_address: "",
        mail_title: "",
        to_name: this.$t('NewSalesListsView.to_name_default'),
        bcc: [],
        send_mode: "auto",
        furigana: "",
        gender: "",
        pref: "",
        city: "",
        street_number: "",
        building_name: "",
        postal_code: "",
        tel: "",
        // step 2
        service_name: "",
        service_detail_summary: "",
        multi_service_flag: false,

        // step 3
        sales_template_id: null,
        template_name: "",
        template_text: "",
        additional_prompt: "",
        is_valid: false,
      },

      // sales_templates: [],

      selectedFile: null,
      selectedFileMail: null,
      responseMessage: "",
      document_title: "",
      document_url: "",
      file_name: "",
      tags: "",
      resourceType: "file",
      isLoading: false,
      tags_format: this.$t('ChatResourceUploadView.tags_format'),
      input_file_name: this.$t('ChatResourceUploadView.file_name'),
      page_name: this.$t('ChatResourceUploadView.page_name'),
      bbc_tagify: null,
    };
  },

  created: function () {
    return this.$store.dispatch("viewMe");
  },

  mounted() {
    // インプットタグの初期化
    const bbc_input = document.querySelector('#bcc');
    this.bbc_tagify = new Tagify(bbc_input);
  },

  beforeUnmount() {
    // コンポーネントの破棄時にWebSocket接続を閉じる
    if (this.ws) {  // <-- この条件を追加
      this.ws.close();
    }
  },

  methods:
  {
    async handleCreate_2(e) {
      e.preventDefault();
      this.isLoading = true;

      // 添付ファイルアップデート
      const blob_name = await this.uploadFileMail();

      const resp = await salesListsApi.createSaleslist({
        list_name: this.saleslist.list_name,
        sender_company_name: this.saleslist.sender_company_name,
        sender_company_url: this.saleslist.sender_company_url,
        sender_name: this.saleslist.sender_name,
        sender_mail_address: this.saleslist.sender_mail_address,
        mail_title: this.saleslist.mail_title,
        to_name: this.saleslist.to_name,
        bcc: this.bbc_tagify.value.map(item => item['value']),
        file_path: blob_name,
        send_mode: this.saleslist.send_mode,
        furigana: this.saleslist.furigana,
        gender: this.saleslist.gender,
        pref: this.saleslist.pref,
        city: this.saleslist.city,
        street_number: this.saleslist.street_number,
        building_name: this.saleslist.building_name,
        postal_code: this.saleslist.postal_code,
        tel: this.saleslist.tel,
        service_name: this.saleslist.service_name,
        multi_service_flag: this.saleslist.multi_service_flag,
        service_detail: "",
        service_detail_summary: this.saleslist.service_detail_summary,

        sales_template_id: this.saleslist.sales_template_id,
        additional_prompt: this.saleslist.additional_prompt,
        is_valid: this.saleslist.is_valid,
        status: 0,
      });

      const newSaleslistId = resp.data.id;
      console.log("newSaleslistId:", newSaleslistId)
      this.isLoading = false;
      this.$router.push("/forsales/salesLists")
    },

    onFileChange(e) {
      this.selectedFile = e.target.files[0];
    },
    onFileChangeMail(e) {
      this.selectedFileMail = e.target.files[0];
      console.log("e.target.files[0]: ", this.selectedFileMail);
      // アップデートファイルのファイルタイプ確認
      if (this.selectedFileMail) {
        let file_type = this.selectedFileMail.name.split('.').pop().toLowerCase();
        if (file_type != "pdf") {
          alert(this.$t('NewSalesListsView.not_pdf'));
          this.selectedFileMail = undefined;
          this.$refs.fileInput.value = "";
          return;
        }
      }
    },

    async createWebSocketConnection() {
      const wsId = Math.random().toString(32).substring(2)
      const ws = new WebSocket(`${process.env.VUE_APP_WEBSOCKET_URL}/ws/${wsId}`);

      ws.onmessage = (event) => {
        (async () => {
          try {
            console.log(event);

            const wsResponseData = JSON.parse(event.data);
            // console.log(wsResponseData);

            if (wsResponseData.error) {
              // this.isLoading = false;
              // this.showModal = true;
              // this.show_messages = false;
            }
            else {
              // *** the main process of return value ***
              await this.processResponse(wsResponseData);
            }
          }
          catch (error) {
            console.error('Error processing WebSocket message:', error);

            // 必要に応じてエラーハンドリングをここに追加
            // (如果需要，請在此處新增錯誤處理)

            // this.isLoading = false;
            // this.showModal = true;
            // this.show_messages = false;
          }
          finally {
            ws.close();
          }
        })();
      };

      return wsId;
    },

    // 接收 Queue 的返回結果
    async processResponse(responseData) {
      console.log("***** responseData:", responseData);

      this.saleslist.service_name = responseData["service_name"]
      this.saleslist.service_detail_summary = responseData["service_detail"]

      // showImportModal.value = false;
      const btnClose = document.getElementById("btnClose");
      btnClose.click();
    },

    async uploadFile() {
      if (!this.selectedFile) {
        alert(this.$t('ChatResourceUploadView.no_files_selected'));
        return;
      }

      try {
        // WebSocketの生成
        const wsId = await this.createWebSocketConnection();

        //this.responseMessage = "Processing...";
        const formData = new FormData();

        formData.append("file", this.selectedFile);

        const metadata = {
          tags: this.tags.split(",").map((tag) => tag.trim()),
          file_name: this.file_name,
          document_url: this.document_url,
          locale: this.$i18n.locale
        };
        formData.append("metadata", JSON.stringify(metadata));

        const response = await upsertFileApi.upload_service(formData, wsId);
        if (response.status != 200) {
          throw new Error("ERROR");
        }

        const responseData = await response.data;
        this.responseMessage = responseData.message;
        console.log("responseMessage(file):", this.responseMessage)
      }
      catch (error) {
        console.error(error);
        this.responseMessage = "Upload failed.";
      }

    },

    async uploadFileMail() {
      if (!this.selectedFileMail) {
        return;
      }

      try {
        const formData = new FormData();
        formData.append("file", this.selectedFileMail);
        const response = await upsertFileApi.upload_service_mail(formData);
        if (response.status != 200) {
          throw new Error("ERROR");
        }

        const responseData = await response.data;
        console.log("blob_name: ", responseData.blob_name);
        return responseData.blob_name;
      }
      catch (error) {
        console.error(error);
        this.responseMessage = "Upload failed.";
      }
    },

    async uploadWebResource() {
      try {
        // WebSocketの生成
        const wsId = await this.createWebSocketConnection();

        //this.responseMessage = "アップロード中...";
        const formData = new FormData();

        formData.append("url", this.document_url);

        const metadata = {
          tags: this.tags.split(",").map((tag) => tag.trim()),
          title: this.document_title,
          document_url: this.document_url,
          locale: this.$i18n.locale
        };
        formData.append("metadata", JSON.stringify(metadata));

        const response = await upsertScrapeApi.upload_service(formData, wsId);
        if (response.status != 200) {
          throw new Error("ERROR");
        }

        const responseData = await response.data;
        this.responseMessage = responseData.message;
        console.log("responseMessage(web):", this.responseMessage)
      }
      catch (error) {
        console.error(error);
        this.responseMessage = "Upload failed.";
      }
    },

  },

};
</script>

<style scoped>
.required::after {
  content: "必須";
  color: #ffffff;
  background: #cc0000;

  font-size: 0.8em;
  padding: 0.3em;
  border-radius: 0.5em;
  margin-left: 0.3em;
}

.prompt::after {
  content: "?";
  color: #ffffff;
  background: #2B66FF;

  font-size: 0.8em;
  padding: 0.4em;
  border-radius: 0.8em;
  margin-left: 0.8em;
}

label {
  margin-right: 2rem;
}

.settings-item {
  margin: 3rem 0;
}

.settings-field {
  margin: 10px 5px;
  padding: 0 1rem;
}

input {
  width: 40%;
}

.settings {
  width: 70%;
  margin: 0 auto;
}

.settings-buttons {
  display: flex;
  justify-content: center;
  gap: 50px;
}

.settings-buttons button {
  border: none;
  width: 20%;
  border-radius: 0;
}

.btn-new {
  margin-right: 50px;
}

.btn-import {
  /* margin-left: 50px; */
  /* width: 468px;
    height: 67px; */
  border-radius: 13px;
  background: rgba(244, 126, 118, 1);
}

.number {
  display: inline-table;
  border-radius: 30px;
  background-color: gray;
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  /* vertical-align: middle; */
  color: #fff;
  margin: 0;
}

.d-modal-content{
  display:flex;            /* 中身のレイアウト用ならこのまま */
  flex-direction:column;   /* 横並びなら不要、縦積みなら追加 */

  position:fixed;          /* 画面に固定 */
  top:50%;
  left:50%;
  transform:translate(-50%, -50%); /* 中心座標へ引き戻し */

  z-index:1060;            /* Bootstrap の 1055 より上に */
  width:80%;
  max-width:500px;
  padding:20px;
  border-radius:8px;
  background:#fff;
  box-shadow:0 5px 15px rgba(0,0,0,.3);
}

.modal-import {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  /* 他の要素より前面に */
}

.form-input {
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

/* スライダートグル（switch） */
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 24px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #4cd964;
}
input:focus + .slider {
  box-shadow: 0 0 1px #4cd964;
}
input:checked + .slider:before {
  transform: translateX(22px);
}
.slider.round {
  border-radius: 24px;
}
.slider.round:before {
  border-radius: 50%;
}

.form-section {
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  padding: 24px 18px 12px 18px;
  margin-bottom: 32px;
  background: #fafbfc;
}
.form-section-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 18px;
  color: #2B66FF;
}
.modal-body {
  white-space: pre-line;
}


</style>
